import { createFileRoute } from '@tanstack/react-router';
import { streamSearchSchema } from '@/features/activity/stream/api';
import { ActivityStreamPage } from '@/features/activity/stream/stream-page';

// S17 · the activity stream: the filters and the open row live in the URL.
export const Route = createFileRoute('/_app/activity/')({
  validateSearch: streamSearchSchema,
  component: ActivityStreamPage,
});
